import { Radio } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ClientsSortEnum } from "../../core/types/managerApiTypes";
import { SortProposalsEnum } from "../../core/types/proposalTypes";
import ButtonCustom from "../ButtonCustom/ButtonCustom";
import classes from "./RadioOptionsBlock.module.scss";

export type OptionType = {
  key: string;
  text: string;
};

type PropsType = {
  buttonIcon?: React.ReactNode;
  value: string;
  setValue: React.Dispatch<React.SetStateAction<SortProposalsEnum | ClientsSortEnum>>;
  optionsObjects: OptionType[];
};

const RadioOptionsBlock = ({
  buttonIcon,
  value,
  setValue,
  optionsObjects,
}: PropsType) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(optionsObjects && optionsObjects[0].key);
  const [selectedValueDisplay, setSelectedValueDisplay] = useState(optionsObjects.find(option => option.key === value) || optionsObjects[0]);

  useEffect(() => {
    if (optionsObjects.length > 0) {
      const initialSelection = optionsObjects.find(option => option.key === value) || optionsObjects[0];
      setSelectedValue(initialSelection.key);
      setSelectedValueDisplay(initialSelection);
    }
  }, [optionsObjects, value]);

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value as SortProposalsEnum;
    const newSelectedOption = optionsObjects.find(option => option.key === newValue);
    if (newSelectedOption) {
      setSelectedValue(newValue);
      setValue(newValue)
      setSelectedValueDisplay(newSelectedOption);
    }
  };

  const handleOptionClick = (optionKey: string) => {
    const newSelectedOption = optionsObjects.find(option => option.key === optionKey);
    if (newSelectedOption) {
      setSelectedValue(optionKey);
      setSelectedValueDisplay(newSelectedOption);
      setValue(optionKey as SortProposalsEnum);
      setIsOpen(false);
    }
  };

  return (
    <div className={classes.container}>
      <ButtonCustom
        style={{
          padding: 0, margin: 0, minHeight: '21px', textTransform: 'lowercase'
        }}
        color="text_button" handleClick={() => setIsOpen(true)}>
        {selectedValueDisplay && selectedValueDisplay.text} {buttonIcon}
      </ButtonCustom>

      {isOpen && (
        <div className={classes.modal_back}>
          <div className={classes.modal_backdrop} onClick={() => setIsOpen(false)} />
          <div className={classes.options_block}>

            {optionsObjects.map((option) => (
              <div key={option.key} className={classes.option} onClick={() => handleOptionClick(option.key)}>

                <span className={classes.label}>{option.text}</span>
                <Radio
                  aria-label="option-selection"
                  name="option-selection"
                  value={option.key}
                  checked={selectedValue === option.key}
                  onChange={handleRadioChange}
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default RadioOptionsBlock;
